import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';

import { Store } from '@ngrx/store';
import { EMPTY, Observable, of, switchMap, take, tap } from 'rxjs';

import { fetchMemberAppointments, fetchMemberProfile } from '@hm/core/stores/member-hub/member-hub.actions';
import { selectMemberProfile } from '@hm/core/stores/member-hub/member-hub.selectors';
import { resetPrescriptionsState } from '@hm/core/stores/prescriptions/prescriptions.actions';

import { MemberProfile } from '@lib/core/models/member.interface';

export const clientProfileResolver: ResolveFn<MemberProfile> = (route: ActivatedRouteSnapshot): Observable<MemberProfile> => {
  const store = inject(Store);
  const clientId: string = route.paramMap.get('id');

  return store.select(selectMemberProfile).pipe(
    switchMap((profile: MemberProfile) => {
      if (!profile || profile.id !== clientId) {
        store.dispatch(resetPrescriptionsState());
        store.dispatch(fetchMemberProfile({ memberId: clientId }));
        return EMPTY;
      } else return of(profile);
    }),
    tap(profile => {
      store.dispatch(fetchMemberAppointments({ userId: profile.userId }));

      return of(profile);
    }),
    take(1)
  );
};
